import { useAPI } from '@shared/lib/composables';
import type { HttpStatusCode } from '~/shared/types';

export interface CostOfKitFormRequest {
  // Заголовок с названием комплекта
  title: string;
  // Специальность клиента
  specialization: string;
  // Название компании
  company?: string;
  // Регион клиента
  region: string;
  // ФИО клиента
  fullName: string;
  // Номер телефона клиента
  phone: string;
  // Email адрес клиента
  email: string;
}

export interface CostOfKitFormResponse {
  success: boolean;
  message?: string;
  status: HttpStatusCode;
  errors?: unknown;
}

/**
 * Запрос стоимости комплекта Консультант Плюс
 * @param requestBody CostOfKitFormRequest
 * @returns Promise<CostOfKitFormResponse>
 */
export function sendCostOfKitForm(requestBody: CostOfKitFormRequest): Promise<CostOfKitFormResponse> {
  const config = useRuntimeConfig();
  const route = useRoute();

  const apiUrl = `${config.public.apiUrl}/v1/forms/kpus/cost-of-kit`;

  const body = {
    form_id: '104c602e-df5f-49c5-a20d-21040e4f7946',
    form_url: config.public.siteUrl + route.fullPath,
    ...requestBody };

  return useAPI<CostOfKitFormResponse>(apiUrl, { method: 'POST', body });
};
